module.exports = {"require":"This field is required"}


//////////////////
// WEBPACK FOOTER
// ./src/wording/pages/validate/ENG.json
// module id = 1331
// module chunks = 120